import { notifications } from '../../api/notifications';
import {
	PostPutSubscriptionsUnsigned,
	SubscriptionsUnsigned,
} from '../../interfaces/notifications';

async function fetchSubscriptionsUnsigned(): Promise<SubscriptionsUnsigned[]> {
	try {
		return await notifications.getSubscriptionsUnsigned();
	} catch (error) {
		throw error;
	}
}

async function addSubscriptionsUnsigned(
	subscribers: PostPutSubscriptionsUnsigned
): Promise<SubscriptionsUnsigned[]> {
	try {
		return await notifications.postSubscriptionsUnsigned(subscribers);
	} catch (error) {
		throw error;
	}
}

async function editSubscriptionsUnsigned(
	id: string,
	subscribers: PostPutSubscriptionsUnsigned
): Promise<SubscriptionsUnsigned[]> {
	try {
		return await notifications.putSubscriptionsUnsigned(id, subscribers);
	} catch (error) {
		throw error;
	}
}

async function deleteSubscriptionsUnsigned(id: string): Promise<null> {
	try {
		return await notifications.deleteSubscriptionsUnsigned(id);
	} catch (error) {
		throw error;
	}
}

export const notificationsService = {
	fetchSubscriptionsUnsigned,
	addSubscriptionsUnsigned,
	editSubscriptionsUnsigned,
	deleteSubscriptionsUnsigned,
};
